'use client';

import { styled } from '@linaria/react';
import cx from 'classnames';
import { memo } from 'react';

// 漲跌方向: -1：無狀態 | 0：平盤 | 1：上漲 | 2：下跌 | 3：漲停 | 4：跌停
enum TickDirection {
  None = -1,
  Flat = 0,
  Rise = 1,
  Fall = 2,
  LimitUp = 3,
  LimitDown = 4
}

export interface QuoteProps {
  change: number;
  children: React.ReactNode;
  tickDirection?: TickDirection;
  isAsideUse?: boolean;
  fontSize?: number;
  bold?: number | string;
}

const ColorQuote = styled.span<{
  change: number;
  tickDirection?: TickDirection;
  fontSize?: number;
  bold?: number | string;
}>`
  font-size: ${({ fontSize }) => `${fontSize ? fontSize : 14}px`};
  line-height: 1;
  letter-spacing: 0.5px;
  font-weight: ${({ bold }) => (bold ? bold : 'normal')};

  background-color: ${({ tickDirection }) => {
    if (tickDirection === TickDirection.LimitUp) return '#e03f19';
    if (tickDirection === TickDirection.LimitDown) return 'rgb(32, 131, 6)';
    return 'transparent';
  }};

  color: ${({ change, tickDirection }) => {
    if (tickDirection && [TickDirection.LimitUp, TickDirection.LimitDown].includes(tickDirection)) return 'white';
    if (change > 0) return '#e03f19';
    if (change < 0) return '#206308';
    return '#515c69';
  }};

  &.aside {
    font-size: 14px !important;
  }
`;

export function Quote({ change, children, tickDirection, fontSize = 0, bold }: QuoteProps) {
  return (
    <ColorQuote
      className={cx('quote-button')}
      change={+change}
      tickDirection={tickDirection}
      fontSize={fontSize}
      bold={bold}
    >
      {children}
    </ColorQuote>
  );
}

export default memo(Quote);
